export const TEST_PERIOD = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
} as const;

export type TestPeriod = (typeof TEST_PERIOD)[keyof typeof TEST_PERIOD];

export const TEST_PERIOD_NOUN: Record<TestPeriod, string> = {
  [TEST_PERIOD.WEEKLY]: 'week',
  [TEST_PERIOD.MONTHLY]: 'month',
};
